import React from "react";
import { ArrowLeft } from "lucide-react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import Header from "../../layouts/Header";
import { useNavigate } from "react-router-dom";
import wtsappImage from "../../assets/images/support/whatsapp.png";
import { Separator } from "../../components/ui/separator";
import { WHATSAPP_SUPPORT_URL } from "../../constants/support";

export default function SupportWhatsapp() {
  const navigate = useNavigate();
  return (
    <>
      <Header />
      <div className="min-h-screen w-full bg-gray-100 flex flex-col">
        <div className="h-[72px] bg-[linear-gradient(86.72deg,#57249C_-10.66%,#EB3366_113.47%)] lg:flex hidden items-center pl-20 text-white ">
          <div className="mr-5 border-rounded rounded-full p-2 border">
            <ArrowLeft
              size={22}
              onClick={() => {
                navigate("/support/index");
              }}
            />
          </div>
          <p className="text-[16px] font-semibold text-white">
            <span className="border-b-[1px] border-white">Support</span>{" "}
            <span className="mx-3 font-normal">/</span> <span>Whatsapp</span>
          </p>
        </div>

        <div className="flex justify-center mt-8 px-4 md:px-16 lg:px-32">
          <div className="max-w-[954px] w-full">
            <Card className="bg-white rounded-2xl border-none overflow-hidden">
              <CardHeader className="px-6 pt-6 pb-4">
                <div className="lg:hidden flex items-center justify-start mb-5">
                  <div className="mr-5 border-rounded rounded-full p-2 border">
                    <ArrowLeft
                      size={26}
                      className="text-[#6D6584] font-normal"
                      onClick={() => {
                        navigate("/support/index");
                      }}
                    />
                  </div>
                  <p className="text-[16px] font-semibold text-[#33125F]">
                    Support
                  </p>
                </div>
                <CardTitle className="text-[20px] font-semibold text-[#6D6584] text-center">
                  Chat with us on WhatsApp
                </CardTitle>
              </CardHeader>

              <CardContent className="px-0 pb-4 space-y-6">
                <p className="text-[16px] font-normal px-[52px] text-[#6D6584] text-center">
                  Our support team is available to assist you with any queries
                  or issues. Click the button below to start a chat with one of
                  our agents on WhatsApp
                </p>
                <Separator />

                <div className="flex justify-center">
                  <a
                    href={WHATSAPP_SUPPORT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center bg-white border border-[#EBE9EF] text-white w-[208px] h-[48px] rounded-full focus:outline-none gap-2 mb-4"
                  >
                    <span className="text-[14px] font-semibold text-[#6D6584]">
                      Chat on Whatsapp
                    </span>
                    <img
                      src={wtsappImage}
                      alt="WhatsApp"
                      className="w-[25px] h-[25px] transition-transform duration-300 ease-in-out hover:scale-110"
                    />
                  </a>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
